<template>
  <div id="Navbar">
    <!-- <el-button @click="" type="text">
      <i class="fz18 el-icon-s-unfold" v-if="isExpand" />
      <i class="fz18 el-icon-s-grid" v-else />
    </el-button>-->
    <div class="flex flex1">
      <el-radio-group v-if="isPC" :value="!isExpand" @change="toggleExpand" size="small">
        <el-radio-button :label="false">Retract</el-radio-button>
        <el-radio-button :label="true">Open</el-radio-button>
      </el-radio-group>
      <!-- <el-cascader
        :options="[]"
        :props="{ expandTrigger: 'hover' }"
        class="ml20"
        filterable
        placeholder="请选择展会"
        size="small"
      ></el-cascader>-->
    </div>
    <el-popover class="avatar" placement="bottom" ref="popover" trigger="hover" width="200">
      <div class="tac">
        <el-button type="danger" @click="logout">Quit</el-button>
      </div>
      <template slot="reference">
        <el-avatar icon="el-icon-user-solid" size="small"></el-avatar>
      </template>
    </el-popover>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import tools from '../utils/tools.js';
export default {
  data() {
    return {
      isPC: true
    };
  },
  created() {
    this.isPC = tools.isPC()
    if (!this.isPC) {
      this.toggleExpand(true)
    }
  },
  watch: {},
  computed: {
    isExpand() {
      return this.$store.state.status.isExpand;
    },
  },
  methods: {
    ...mapMutations("status", ["toggleExpand"]),
    logout() {
      localStorage.removeItem("userInfo");
      this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
    },
  },
};
</script>

<style lang="less" scoped>
#Navbar {
  border-bottom: 1px solid #e6e6e6;
  align-items: center;
  padding: 0 20px;
  display: flex;
  height: 60px;
  width: 100%;

  .avatar {
    justify-self: flex-end;
  }
}
</style>
